module.exports = __webpack_public_path__ + "media/golf_course.3929abc4.svg";